export default "__VITE_ASSET__BVHnAKa$__"